<!--头部导航-->
<template>
  <div :class="[[isHome ? 'header-class__home' : 'header-class'], 'container']">
    <div class="displayStart">
      <div class="logo" style="cursor: pointer" @click="toOverFlow">
        <img
          :src=" yunZhouOtherType == 2 ? 'https://cdn-image.yucrm.cn/4d04adb6f2f9452dbae3e21f2c152cdc.png' : logoImg"
          style="width: 120px; height: 40px"
          alt
        />
      </div>
      <div class="module displayStart">
        <!--<el-menu router class="el-menu-demo" mode="horizontal" @select="topTab">
            <el-menu-item :index="item.path" v-for='(item,ind) in headItem'>{{item.tittle}}</el-menu-item>
        </el-menu>-->
        <!-- <div :class="{'tabActive':topActive===ind}" class="item" @click="topTab(ind,item)" v-for="(item,ind) in headItem" :key="ind">
          {{item.tittle}}
          <div :class="{'active':topActive===ind}"></div>
        </div> -->
        <search @itemClick="itemClick" />
        <nav class="nav" ref="mainHeader" v-if="yunZhouOtherType != 2">
          <template v-for="(item, ind) in headItem">
            <div
              class="nav-item"
              :style="{ position: 'relative' }"
              :class="{ navActive: topActive == ind }"
              @click="topTab(ind, item)"
              v-if="item.tittle == '首页'"
              :key="ind"
            >
              {{ item.tittle }}
            </div>
            <div
              class="nav-item"
              :style="{ position: 'relative' }"
              :class="{ navActive: topActive == ind }"
              @click="topTab(ind, item)"
              v-if="item.tittle == '互动'"
              :key="ind"
            >
              {{ item.tittle }}
            </div>
            <!-- <div
              class="nav-item bi"
              :style="{ position: 'relative'}"
              :class="{ navActive: topActive == ind }"
              @click="topTab(ind, item.children.find(child => child.path == 'bi'))"
              v-if="item.tittle=='数据'&&item.children.some(child=>child.path=='bi')"
              :key="ind"
            >
              {{ '云起 BI' }}
            </div> -->
            <!-- <div
              class="nav-item"
              :style="{ position: 'relative'}"
              :class="{ navActive: topActive == ind }"
              @click="topTab(ind, item)"
              v-if="item.tittle.indexOf('云起BI') == -1 && showMenuPath.includes(item.path)"
              :key="ind"
            >
              {{ item.tittle }}
            </div>
            <div
              v-else-if="item.tittle == '行业专区预览页'"
              class="nav-item"
              style="position: relative;padding-right: 40px;width: 125px;"
              @click="toIndustryPreview"
              :key="ind+'1'"
            >
              行业专区
              <img style="position:absolute;top:17px;right:0px" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/newN.svg" alt="" />
            </div>
            <div
              v-else-if="item.path == '/bi' && showMenuPath.includes(item.path)"
              class="nav-item"
              style="position: relative;"
              @click="toBi(item)"
              :key="ind+''"
            >
              {{ item.tittle }}
            </div>
            <div
              v-else-if="showMenuPath.includes(item.path)"
              class="nav-item"
              style="position: relative;width: 72px;"
              :class="{ navActive: topActive == ind }"
              @click="topTab(ind, item)"
              :key="ind+'2'"
            >
              {{ item.tittle }}
            </div> -->
          </template>
          <div
            class="nav-item bi"
            :style="{ position: 'relative' }"
            @click="jumpToBi()"
          >
          <el-dropdown @command="handleBI" v-if="biInfos.type==3">
            <span class="bi-menu">{{ "云起 BI" }}<i class="el-icon-arrow-down down-icon"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="云起BI">云起BI</el-dropdown-item>
              <el-dropdown-item command="云舟BI">云舟BI</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <span v-else>{{ biInfos.type==1 ? "云舟 BI":"云起 BI" }}</span>
          </div>
          <div
            v-if="isShowDongMenu"
            class="nav-item"
            :style="{ position: 'relative' }"
            @click="jumpToCustomer"
          >
            {{ "客服工具" }}
          </div>
          <div
            v-if="isShowShopDecoration"
            :class="['nav-item shopDecoration',{ navActive: topActive == 'zhipuDecoration' }]"
            :style="{ position: 'relative' }"
            @click="jumpToShopDecoration('zhipuDecoration')"
          >
            <span>店铺装修</span>
          </div>
          <!-- <span v-if="navIogo" @click="handleUrl()" style="padding-top: 7px;" class="nav-item navLeft"
            ><img style="width:100px" src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/shy.gif" alt=""
          /></span> -->

          <span
            @click="handleLink(val)"
            class="nav-item nav-pcImgUrl"
            v-for="val in popList"
            :key="val.id"
            style="width: 100px; position: relative"
          >
            <img
              style="
                max-width: 100px;
                height: 30px;
                top: 31%;
                position: absolute;
              "
              :src="val.pcImgUrlPlatform"
              alt=""
            />
          </span>
          <!-- <i class="nav-underline" :style="navLineStyle"></i> -->
        </nav>
      </div>
    </div>

    <div class="rightContent">
      <!-- <jd-old-button
        style="margin-right: 20px"
        v-if="canReturn"
        @click="back2CRM"
        type="blueBorder"
        >切换旧版</jd-old-button
      > -->
      <div v-if="access" id="whiteBar"></div>
      <div
        v-if="access"
        class="white-bar"
        @click="handleShowWhiteBar"
      >
        <img
          src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/white-bar-entrance.png"
          style="width: 90px; height: 34px;"
          alt=""
        />
      </div>
      <div
        v-if="hasAiPermission"
        class="ai_button"
        @click="showAiService = true"
      >
        <!-- <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/ai.svg" alt style="width: 100%" /> -->
        <img
          src="https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/ai-smart-icon.svg"
          style="width: 116px; height: 38px; display: block"
          alt=""
        />
      </div>
      <!-- 帮助中心 -->
      <el-popover placement="bottom" width="236" trigger="hover">
        <div class="displayStart helpBlock" slot="reference">
          <!-- <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/newHome/helpNew.png" alt style="width:88px" class="helpCenter"/> -->
          <div class="tips">
            <img
              src="../assets/homePage/help2.png"
              style="width: 14px; margin-right: 8px"
            />
            帮助中心
          </div>
        </div>
        <div></div>
        <!-- 帮助中心 -->
        <div class="customerService">
          <div class="help">
            <a
              href="https://www.yuque.com/yunduanxincrm/mrkpcq?#"
              style="text-decoration: none; color: #333333"
              target="_blank"
            >
              <div class="helpNoHover">
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/help.svg"
                  alt
                  style="width: 14px; height: 14px"
                />&nbsp;帮助文档
              </div>
              <div class="helpHover">
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/helpHover.svg"
                  alt
                  style="width: 14px; height: 14px"
                />&nbsp;帮助文档
              </div>
            </a>
          </div>

          <div class="toService displayStart">
            <div class="title">客服热线：</div>
            <div class="phone">
              020-28970151
              <span class="phoneBtn">
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/copy.svg"
                  alt
                  @click="copyBtn('020-28970151')"
                  style="width: 16px; height: 16px; cursor: pointer"
                  class="copyBtn" />
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/copyHover.svg"
                  alt
                  @click="copyBtn('020-28970151')"
                  style="width: 16px; height: 16px; cursor: pointer"
                  class="copyBtnHover"
              /></span>
            </div>
          </div>
          <div class="toService displayStart">
            <div class="title">周末客服：</div>
            <div class="phone">
              18925068928
              <span class="phoneBtn">
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/copy.svg"
                  alt
                  @click="copyBtn('18925068928')"
                  style="width: 16px; height: 16px; cursor: pointer"
                  class="copyBtn"
                />
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/copyHover.svg"
                  alt
                  @click="copyBtn('18925068928')"
                  style="width: 16px; height: 16px; cursor: pointer"
                  class="copyBtnHover"
                />
              </span>
            </div>
          </div>
          <div class="wechatService">
            <div class="QRcode">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/code-four.png"
                alt
                style="width: 100%"
              />
              <span calss="title">云起小助手A</span>
            </div>
            <div class="QRcode">
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/code-five.png"
                alt
                style="width: 100%"
              />
              <span calss="title">云起小助手B</span>
            </div>
          </div>
        </div>
      </el-popover>

      <!-- 店铺资产 -->
      <el-popover placement="bottom" width="382" trigger="hover" v-if="yunZhouOtherType != 2">
        <div class="displayStart shopBlock" slot="reference">
          <!-- <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/newHome/shopNew.png" alt style="width:88px" class="shopIcon"/> -->
          <div class="tips">
            <img
              src="../assets/homePage/ye.png"
              style="width: 14px; margin-right: 8px"
            />
            余额
          </div>
        </div>
        <!-- 内容-->
        <div class="details">
          <div class="shopTitle">
            <div>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/shopIcon.svg"
                alt
                style="width: 18px"
              />
            </div>
            <div class="title">当前店铺资产</div>
          </div>
          <div class="details_top">
            <div>
              <div class="autograph">
                {{
                  sellerPlatform.paySmsTotal - sellerPlatform.useSmsTotal
                    ? sellerPlatform.paySmsTotal - sellerPlatform.useSmsTotal
                    : sellerPlatform.paySmsTotal - sellerPlatform.useSmsTotal ==
                      0
                    ? 0
                    : "--"
                }}
              </div>
              <div class="txt">短信(条)</div>
            </div>
            <div>
              <div class="autograph">
                {{ fuxinSms ? fuxinSms : fuxinSms == 0 ? 0 : "--" }}
              </div>
              <div class="txt">富信(条)</div>
            </div>
            <div>
              <div class="autograph">
                {{
                  sellerPlatform.payCardSmsTotal -
                  sellerPlatform.useCardSmsTotal
                    ? sellerPlatform.payCardSmsTotal -
                      sellerPlatform.useCardSmsTotal
                    : sellerPlatform.payCardSmsTotal -
                        sellerPlatform.useCardSmsTotal ==
                      0
                    ? 0
                    : "--"
                }}
              </div>
              <div class="txt">卡片短信(条)</div>
            </div>
            <div>
              <div class="autograph">
                {{
                  dongDongBalance || 0
                }}
              </div>
              <div class="txt">咚咚消息(条)</div>
            </div>
            <button
              v-zoom="{ name: '短信充值', from: '首页' }"
              class="recharge"
              @click="goRecharge"
            >
              充值
            </button>
          </div>
          <div class="details_bottom" v-if="newplatformFlag">
            <div class="left_content" style="margin-top: 12px">
              <div>
                <span class="txt">云舟到期时间：</span>
                <span class="time">
                  {{
                    sellerPlatform.platformVersionEndDate
                      ? sellerPlatform.platformVersionEndDate
                      : "--"
                  }}</span
                >
              </div>
              <el-popover placement="bottom" trigger="hover">
                <div style="font-size: 12px; color: #999999">
                  如需续费软件，请联系您的专属顾问哦~
                </div>
                <div
                  class="displayBetween"
                  v-zoom="{ name: '软件续费', from: '首页' }"
                  slot="reference"
                  style="width: 48px; margin-top: 7px; cursor: pointer"
                >
                  <div class="payBtn">续费</div>
                  <img
                    src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/go_blue.svg"
                    alt
                    style="width: 12px"
                  />
                </div>
              </el-popover>
            </div>
            <div class="left_content" style="margin-top: 12px">
              <div>
                <span class="txt">CRM授权到期时间：</span>
                <span class="time">
                  {{ 
                    sellerPlatform.crmInvalidateDate 
                      ? sellerPlatform.crmInvalidateDate.substring(0, 10) 
                      : "--"
                  }}</span
                >
                <el-tooltip content="云舟标准版订购到期时间" placement="top" effect="dark">
                  <span class="question-icon">?</span>
                </el-tooltip>
              </div>
              <div
                class="displayBetween"
                v-zoom="{ name: '软件续费', from: '首页' }"
                @click="goCRM"
                style="width: 48px; margin-top: 7px; cursor: pointer"
              >
                <div class="payBtn">续费</div>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/go_blue.svg"
                  alt
                  style="width: 12px"
                />
              </div>
            </div>

            <div class="left_content" style="margin-top: 12px">
              <div>
                <span class="txt">互动授权到期时间：</span>
                <span class="time">
                  {{
                    sellerPlatform.hdInvalidateDate
                      ? sellerPlatform.hdInvalidateDate.substring(0, 10)
                      : "--"
                  }}</span
                >
                <el-tooltip content="京获客订购到期时间" placement="top" effect="dark">
                  <span class="question-icon">?</span>
                </el-tooltip>
              </div>
              <div
                class="displayBetween"
                v-zoom="{ name: '软件续费', from: '首页' }"
                @click="goHD"
                style="width: 48px; margin-top: 7px; cursor: pointer"
              >
                <div class="payBtn">续费</div>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/go_blue.svg"
                  alt
                  style="width: 12px"
                />
              </div>
            </div>
          </div>
          <div class="details_bottom" v-else>
            <div class="bottom_content">
              <div>
                <div>
                  <span class="text">标准版软件有效期/天：</span>
                  <span>{{ daysSoft }}</span>
                </div>
                <jd-old-button type="darkBlue" @click="goJM">续费</jd-old-button>
              </div>
              <span class="text">有效期至：{{ invalidateDate || "--" }}</span>
            </div>
          </div>
        </div>
      </el-popover>

      <!-- 切换店铺 -->
      <!-- <el-popover placement="bottom" trigger="hover" :visible-arrow="true">
        <div class="displayStart head-name " slot="reference">
          <div class="head-name-tit">{{ shopTitle }}</div>
          <i style="position: relative; vertical-align: middle" class="el-icon-arrow-down"></i>
        </div>
        <div>
          <div v-for="(item, index) in switchListStore" :key="index" class="switch-body1">
            <div class="switch-content"  @click="toggleSwitch(item)" 
            :class="item.shopTitle == shopTitle?'active':''">
              <div class="shop-name">
                <span>{{ item.shopTitle }}</span>
                <div class="shop-name-default" v-if="item.defaultFlag">默认</div>
                <div v-else>
                  <div class="shop-name-empty"></div>
                  <div class="shop-name-default shop-name-setDefault" @click.stop="setDefault(item)">设为默认</div>
                </div>
              </div>
              <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/click.svg" alt style="width:15px" 
                v-if="item.shopTitle == shopTitle"/>
            </div>
          </div>
        </div>

      </el-popover> -->

      <!-- 员工信息 -->
      <div>
        <el-popover
          placement="bottom"
          width="254"
          trigger="hover"
          style="padding: 0"
          class="platformFlag"
        >
          <div slot="reference" class="displayStart">
            <img
              src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/newHome/topMember.svg"
              alt
              style="width: 26px"
            />
            <div class="shopTitle">
              <div class="outWidth fs12 colorfff">
                <div>{{ shopTitle }}</div>
                <div class="fs12 colorfff mt4">{{ encryptedUserName }}</div>
              </div>
              <!-- <encrypt :text="sellerPlatform.platformAccountInfo.userName + ''" :isNeed="false" decryptText="" :textColor="'#999999'"></encrypt> -->
            </div>
            <!--  向下的箭头按钮 -->
            <img
              src="@/assets/homePage/down.png"
              style="width: 12px; height: 12px"
            />
          </div>

          <div>
            <!-- 切换店铺 -->
            <div class="shopSwitch" :style="newplatformFlag ? {} : { 'border-bottom': 'none' }">
              <div
                v-for="(item, index) in switchListStore"
                :key="index"
                class="switch-body1"
              >
                <div
                  class="switch-content"
                  @click="toggleSwitch(item)"
                  :class="newplatformFlag && item.shopTitle == shopTitle ? 'active' : ''"
                  v-if="yunZhouOtherType != 2 || (yunZhouOtherType == 2 && item.shopTitle == shopTitle)"
                >
                  <div class="shop-name">
                    <span class="outWidth">{{
                      newplatformFlag
                        ? item.shopTitle
                        : item.claimerShopTitle == shopTitle
                        ? item.shopTitle
                        : item.claimerShopTitle
                    }}</span>
                    <div
                      class="shop-name-default"
                      v-if="item.defaultFlag && newplatformFlag"
                    >
                      默认
                    </div>
                    <div v-else>
                      <div class="shop-name-empty"></div>
                      <div
                        v-if="newplatformFlag"
                        class="shop-name-default shop-name-setDefault"
                        @click.stop="setDefault(item)"
                      >
                        设为默认
                      </div>
                    </div>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/click.svg"
                      alt
                      style="width: 15px"
                      v-if="item.shopTitle == shopTitle && newplatformFlag"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="shopSwitch" style="border-bottom: none;" v-else>
              <div class="switch-body1">
                <div class="switch-content active">
                  <div class="shop-name">
                    <span class="outWidth">{{ shopTitle }}</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/platform/click.svg"
                      alt
                      style="width: 15px"
                    />
                  </div>
                </div>
              </div>
            </div> -->
            <!-- 员工信息 -->
            <div v-if="newplatformFlag && yunZhouOtherType != 2">
              <div class="information" style="margin-top: 8px">
                员工姓名：<encrypt
                  :needMockCheck="true"
                  :text="sellerPlatform.platformAccountInfo.userName + ''"
                  decryptText=""
                ></encrypt>
              </div>
              <div class="displayBetween information">
                <div>
                  员工手机：<encrypt
                    :text="
                      sellerPlatform.platformAccountInfo.mistinessMobile + ''
                    "
                    :decryptText="sellerPlatform.platformAccountInfo.mobile"
                  ></encrypt>
                </div>
                <jd-old-button @click="changePhone()" type="blueText"
                  >修改</jd-old-button
                >
              </div>
              <div class="information">
                员工性别：
                <span v-if="sellerPlatform.platformAccountInfo.sex == 1"
                  >女</span
                >
                <span v-else-if="sellerPlatform.platformAccountInfo.sex == 2"
                  >未知</span
                >
                <span v-else>男</span>
              </div>
              <div class="information">
                所属部门：{{ sellerPlatform.platformAccountInfo.deptName }}
              </div>
              <div class="displayBetween information">
                <div>
                  登录账号：{{
                    sellerPlatform.platformAccountInfo.loginAccount
                  }}
                </div>
                <jd-old-button @click="handleChangePwd()" type="blueText"
                  >修改密码</jd-old-button
                >
              </div>
            </div>
            <div
              class="callkf1"
              @click="log_out"
              style="width: 100%; height: 32px; margin-top: 8px"
            >
              退出登录
            </div>
          </div>
        </el-popover>
      </div>

      <!-- 欢迎语 -->
      <!-- <div class="welcome">
        欢迎您
      </div> -->
    </div>

    <!-- 生效弹窗列表 -->
    <!-- <el-dialog title="公告内容" :visible.sync="DialogVisible">
      <div v-html="linkContents"></div>
    </el-dialog> -->
    <el-dialog
      title="公告内容"
      :close-on-click-modal="false"
      :append-to-body="true"
      :visible.sync="isPopVisiv"
      width="800px"
      :class="{ dialongTransition12: popItem.type == 0 }"
    >
      <div
        style="display: flex; justify-content: center"
        v-if="popItem.type == 0"
      >
        <div style="position: relative">
          <img
            @click="handleUrl"
            class="pointer"
            :src="popItem.pcPicPlatform"
            alt
            style="max-width: 100%; margin: 0 auto; margin-top: 38px"
          />
          <img
            class="pointer"
            style="position: absolute"
            @click="isPopVisiv = false"
            src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/btn_关闭.png"
            alt=""
            width="29"
            height="29"
          />
        </div>
      </div>
      <template v-else>
        <div
          style="height: 500px; overflow-y: auto; padding-bottom: 20px"
          v-html="popItem.richText"
        ></div>
      </template>
    </el-dialog>

    <!-- ai弹窗 -->
    <ai-dialog :isShow.sync="showAI" @change-types="changeAiType"></ai-dialog>

    <!-- ai智能助手 -->
    <!-- <ai-service
      :isShow.sync="showAiService"
      :userInfo="sellerPlatform.platformAccountInfo"
      @change-types="changeAiType"
      v-if="showAiService"
    ></ai-service> -->
    <ai-tools v-model="showAiService"/>

    <!-- 修改手机号弹窗 -->
    <jd-dialog
      v-if="newplatformFlag"
      title="修改手机号"
      :visible.sync="phoneDialog"
      width="450px"
      :close-on-click-modal="false"
      :append-to-body="true"
    >
      <div class="export-dialog-wrapper new-input-box">
        <el-form ref="phoneForm" :model="phoneForm" label-width="84px">
          <el-form-item label="原手机号" v-if="sellerPlatform.platformAccountInfo && sellerPlatform.platformAccountInfo.mistinessMobile">
            {{ sellerPlatform.platformAccountInfo.mistinessMobile }}
          </el-form-item>
          <el-form-item label="新手机号" prop="mobile">
            <el-input
              v-model="phoneForm.phone"
              placeholder="请输入"
              style="width: 320px"
            ></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="vcode" style="margin-bottom: 0">
            <el-input
              maxlength="6"
              v-model="phoneForm.code"
              placeholder="请输入"
              style="width: 196px"
            >
              >
            </el-input>
            <jd-button
              type="lightBlue"
              style="margin-left: 8px"
              width="114px"
              @click="getPhoneCode"
              :disabled="phonecodeDisabled"
              :styleTextObj="{ width: '114px', height: '32px' }"
              >{{ phonecodeMsg }}</jd-button
            >
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <jd-button
          type="blue"
          size="small"
          @click="savePhone"
          >保存</jd-button
        >
        <jd-button
          size="small"
          @click="closeDialog"
          >取消</jd-button
        >
      </span>
    </jd-dialog>

    <!-- 修改密码弹窗 -->
    <changePwd
      v-if="showEditPwd"
      :showChangePwd="showEditPwd"
      :pwdForm="editForm"
      @close="handleEditPwdClose"
      @saveEditSave="handleEditPwdClose"
    />

    <!-- 有效期过期弹窗 -->
    <el-dialog title="提示" :visible.sync="validityDialog" width="30%">
      <div>
        该店铺还未授权客服工具，<span class="validityText" @click="toLaunch"
          >请前往订购授权>></span
        >
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="validityDialog = false">取 消</el-button>
        <el-button type="primary" @click="validityDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const logoImg = require("@/assets/homePage/logo.png");
import { mapState, mapMutations } from "vuex";
import shieldList from "@/utils/shield.js";
import { loginController } from "@/api/activityController";
import {
  getSellerInfo,
  getShopInfo,
  switchShop,
  returnOldSystem,
  getMenuList,
  getSeller,
  homeController,
  getSellerPlatform,
  getCheckCode,
  updatePlatformAccountMobile,
  decryptPhone,
  setDefault,
  getJumpDD,
  back2CRM,
  getYunzhouBiInfo
} from "@/api/sellerController";
import {newAndOldShopIsPopUp,getMAToken,getOnceToken} from "@/api/whiteBar";
import { querySellerSetting } from "@/api/backstage/a_setting";
import { logout } from "@/api/login";
import axios from "axios";
import { getSysConfigByKe } from "@/api/manage/memberCrowdController";
import aiDialog from "@/components/ai-message.vue";
import aiService from "@/components/ai/aiService.vue";
import encrypt from "@/components/common/encryptEye.vue";
import changePwd from "@/views/permissionManagement/components/changePwd/index.vue";
import search from "./common/search.vue";
import JdOldButton from "./new/jd-button.vue";
import aiTools from "@/components/ai/aiTools.vue";
import {getShopList} from "@/api/public";
// import { cutHostToSonShop } from "@/api/login";
export default {
  name: "page-header",
  props: {
    paths: {
      type: Array,
      require: true,
    },
  },
  components: {
    aiDialog,
    changePwd,
    encrypt,
    search,
    aiService,
    JdOldButton,
    aiTools,
  },
  watch: {
    paths(newVal, oldVal) {
      if (this.paths && this.paths.length > 0) {
        let ind = this.paths[0].index;
        // 找到店铺装修的索引
       let pathObj = this.paths.find(item=>item.path=='zhipuDecoration')
        if(pathObj) {
          ind = pathObj.path;
        }
        this.topActive = ind;
        if (this.topActive == 5 && this.$route.query.venderId) {
          this.loginEvent();
        }
        //只需要刷新的时候调用一次
        this.bus.$emit("topActive", { index: ind, item: this.headItem[ind] });
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });
      }
    },
  },
  data() {
    return {
      shopList: [],
      hasAiPermission: false,
      logoImg,
      appKey: "22AF00009B3D46B8DECBC457090B3560",
      componentId: "B8CABEC9CBBD5815C4C7BB89D7D45461",
      access: false,
      frontComponentUrl:"",
      reqId: "",
      pathsOne: "",
      showAI: false, //AI弹窗
      showAiService: false,
      //Note--剩余富信短信
      fuxinSms: "",
      isPopVisiv: false,
      popItem: {},
      popList: [],
      topActive: 0,
      once: false,
      //实时信息数据
      softwarename: "",
      theme: "",
      switchList: [],
      softwareInfo: {
        versionName: "POP版",
      },
      accountSwitches: true,
      activeNavStyle: { left: 0, width: 0 },
      currentNavStyle: null,
      screenWidth: document.body && document.body.clientWidth, // 屏幕尺寸
      venId: null, //商家编号
      navIogo: false,
      pathList: [],
      permissionPath: JSON.parse(localStorage.getItem("permissionPath")) || [],
      phoneDialog: false, //修改手机号弹窗
      phonecodeMsg: "发送验证码",
      phonedown: 60, // 更换手机验证倒计时秒数
      phonecodeDisabled: false, // 更换手机验证是否可点击
      phoneForm: {
        phone: "",
        code: "",
      },
      shopTitle: "",
      showEditPwd: false, //密码弹窗
      sellerPlatform: {
        useCardSmsTotal: "",
        payCardSmsTotal: "",
        useSmsTotal: "",
        paySmsTotal: "",
        platformversionEndDate: "",
        crmInvalidateDate: "", //CRM数据授权有效期,空代表未订购 yyyy-mm-dd
        hdInvalidateDate: "", //互动数据授权有效期,空代表未订购 yyyy-mm-dd
        platformAccountInfo: {
          mistinessMobile: "",
        },
      }, //平台版用户信息
      platformFlag: false, //是否是平台版
      loginUserInfo: {
        shopTitle: "",
      },
      encryptPhone: "",
      // "/interactiveMarketing", 互动管理
      showMenuPath: ["/backstage", "/bi", "/bi_preview"],
      validityDialog: false, // 店铺授权弹窗
      // newplatformFlag: true, //标准版标志
      dongDongBalance: 0, //咚咚余额
    };
  },
  computed: {
    // 云舟其他类型 1京获客旗舰版 2云起追单版
    yunZhouOtherType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || 1;
    },
    newplatformFlag() {
      return this.$store.getters.loginUserInfo.platformFlag;
    },
    canReturn() {
      return this.$store.getters.loginUserInfo.canReturn;
    },
    ...mapState({
      globalBG: "globalBG",
      switchListStore: "switchList",
    }),
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 订购类型
    subscribeType() {
      return this.$store.getters.loginUserInfo.subscribeType;
    },
    headItem() {
      return this.$store.state.route;
    },
    navLineStyle() {
      let style = this.currentNavStyle || this.activeNavStyle;
      return {
        width: `${style.width}px`,
        left: `${style.left}px`,
      };
    },
    picImg() {
      var defaultImg = "https://cdn-image.yucrm.cn/images/jd-front-platform/images/home/header.png";

      var img = defaultImg;
      if (
        this.$store.getters.loginUserInfo &&
        this.$store.getters.loginUserInfo.picPath
      ) {
        img = this.$store.getters.loginUserInfo.picPath;
      }
      return img;
    },
    invalidateDate() {
      var invalidateDate =
        this.$store.getters.loginUserInfo.standardInvalidateDate;
      if (invalidateDate) {
        invalidateDate = invalidateDate.substr(0, 10);
      }
      return invalidateDate;
    },
    daysSoft() {
      var str = "--";
      var invalidateDate = this.invalidateDate;
      if (invalidateDate) {
        str = this.daysBetween(invalidateDate, this.getTodayYMD()) - 1;
      }
      return str;
    },
    preDaysSoft() {
      var str = "--";
      var preInvalidateDate = this.preInvalidateDate;
      if (preInvalidateDate) {
        let testDate = this.daysBetween(preInvalidateDate, this.getTodayYMD());
        str = testDate < 1 && testDate >= 0 ? 0 : testDate;
      }
      return str;
    },
    subscribeType() {
      return this.$store.getters.loginUserInfo.subscribeType;
    },
    // 高级版有效日期
    preInvalidateDate() {
      var invalidateDate =
        this.$store.getters.loginUserInfo.premiumEditionInvalidateDate;
      if (invalidateDate) {
        invalidateDate = invalidateDate.substr(0, 10);
      }
      return invalidateDate;
    },
    // 标准版剩余天数
    // daysSoft() {
    //   var str = "--";
    //   var invalidateDate = this.invalidateDate;
    //   if (invalidateDate) {
    //     str = this.daysBetween(invalidateDate, this.getTodayYMD());
    //   }
    //   return str;
    // },
    // 高级版剩余天数
    preDaysSoft() {
      var str = "--";
      var preInvalidateDate = this.sellerPlatform.platformVersionEndDate;
      if (preInvalidateDate) {
        str = this.daysBetween(
          preInvalidateDate.substring(0, 10),
          this.getTodayYMD()
        );
      }
      return str;
    },
    //CRM剩余天数
    crmDaysSoft() {
      var str = "--";
      var crmInvalidateDate = this.sellerPlatform.crmInvalidateDate;
      console.log("crmInvalidateDate", crmInvalidateDate);
      if (crmInvalidateDate) {
        str = this.daysBetween(crmInvalidateDate, this.getTodayYMD());
      }
      return str;
    },
    //互动剩余天数
    hdDaysSoft() {
      var str = "--";

      var hdInvalidateDate = this.sellerPlatform.hdInvalidateDate;
      console.log("hdInvalidateDate", hdInvalidateDate);
      if (hdInvalidateDate) {
        str = this.daysBetween(
          hdInvalidateDate.substr(0, 10),
          this.getTodayYMD()
        );
      }
      return str;
    },
    isHome() {
      return this.$route.fullPath == "/home";
    },
    // 是否显示咚咚客服工具入口
    isShowDongMenu() {
      return this.$store.state.route.some((s) => s.path == "dongTool");
    },
    // 显示店铺装修【智铺】入口
    isShowShopDecoration() {
     const routerObj = this.$store.state.route
     let flag = false
     if(routerObj.length>0) {
        const routeData = routerObj.find((s) => s.path == "/member")
        if(routeData && routeData.children) {
          flag = routeData.children.some((s) => s.path == "zhipuDecoration")
        }
     } 
      return flag;
    },
    // 加密用户名称
    encryptedUserName() {
      let text =
        (this.sellerPlatform &&
          this.sellerPlatform.platformAccountInfo &&
          this.sellerPlatform.platformAccountInfo.userName) ||
        "";
      // 若传入文本为空，直接返回空字符串
      if (!text) return "";

      let end = "";

      if (text.length > 6) {
        end = text.slice(7);
        return text.substring(0, 3) + "****" + end;
      } else {
        if (text.length > 2) end = text.charAt(text.length - 1);
        return text.charAt(0) + "**" + end;
      }
    },
    biInfos() {
      return this.$store.state.biInfo;
    },
  },
 async mounted() {
    this.getFirstWhiteBarPop()
    var flag = sessionStorage.getItem("flag");
    this.bus.$on("topHeader", (obj) => {
      this.topTab(obj.index, obj.item);
    });
    console.log("location.pathname:", this.$route.path);
    if (
      location.pathname !== "/login" &&
      location.pathname !== "/" &&
      location.pathname !== "/platform/login" &&
      location.pathname !== "/platform/redirection" &&
      location.pathname !== "/platformLogin" &&
      location.pathname !== "/platform/platformLogin"
    ) {
      this.getBindList();
      // 获取云起BI信息
      await this.getBIApi()
      // 获取菜单
      this.getMenuData();
      // 顶部栏图
      this.popups();
      //平台版
      // this.getSellerPlatform()
      // this.getSeller()
    }
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body && document.body.clientWidth;
        that.screenWidth = window.screenWidth + 17; // 17 估计是滚动条的距离
        this.$nextTick(() => {
          this.activeNavStyle = this.getNavStyle(this.topActive);
        });
      })();
    };
    // this.newplatformFlag = JSON.parse(
    //   sessionStorage.getItem("sellerPlatform")
    // ).platformFlag;
  },

  methods: {
    // 跳转店铺装修
    jumpToShopDecoration(index) {
      this.topActive = index;
      this.$router.push({ 
        path: "/member/zhipuDecoration",
      })
    },
    handleBI(val) {
      if(val=="云起BI") {
        window.open(this.biInfos.yqBiUrl,'_blank')
      } else {
        let targetArr = this.headItem.filter((item) => item.path == "/analysis");
        let isHasYZBi = targetArr[0].children.some((item) => item.path == "bi");
        if (isHasYZBi) {
          let targetRoute = targetArr[0].children.filter(
            (item) => item.path == "bi"
          );
          window.open(
            "/platform/" +
              targetRoute[0].path +
              "/" +
              targetRoute[0].children[0].path,
            "_blank"
          );
        } else {
          this.$router.push({
            path: "/analysis/bi_preview",
          });
        }
      }
    },
    handleShowWhiteBar() {
      this.getWhiteBarPop()
    },
    // 调用白条弹窗
    getJdMicroAppOpen() {
      if(!window.jdMicroAppOpenInstance) {
        window.jdMicroAppOpenInstance = window.jdMicroAppOpen.create();
      }
      jdMicroAppOpenInstance.clear()
      // 打开组件
      jdMicroAppOpenInstance.open({
        appKey: this.appKey,
        target: "#whiteBar",
        componentId: this.componentId,
        getOnceToken: async() => {
          const res = await getMAToken({componentId: this.componentId})
          const res1 = await getOnceToken({maTokee: res.data.token})
          return res1.data.token
        },
        customParams: {
          sourceType: 'ISVYDX',
          reqId: this.reqId
        }
      });
    },
    getWhiteBarPop() {
      newAndOldShopIsPopUp().then((res)=>{
        if(res.code==1) {
          this.access = res.data.access
          this.reqId = res.data.reqId
          this.frontComponentUrl = res.data.frontComponentUrl
          if(this.access) {
            this.getJdMicroAppOpen()
          }
        }
      })
    },
    getFirstWhiteBarPop() {
      newAndOldShopIsPopUp().then((res)=>{
        if(res.code==1) {
          this.access = res.data.access
        }
      })
    },
    back2CRM() {
      // 事件埋点
      this.buriedPoint(2, "切换旧版", "首页", "首页",null,()=>{
        back2CRM().then((res) => {
          console.log(res);
          // location.href(res.data)
          window.location = res.data;
        })
      });
    },
    ...mapMutations({
      editUserInfo: "LOGINUSERINFO",
      editPointUserInfo: "POINTUSERINFO",
      getSwitchList: "getSwitchList",
      saveShopInfo: "SHOPINFO",
    }),
    // 设置默认店铺
    setDefault(item) {
      setDefault({ sellerNick: item.hostshop }).then((res) => {
        if (res.code == 1) {
          this.getBindList();
          this.$message.success(res.data);
        }
      });
    },
    handleUrl() {
      if (this.popItem.pcUrl) {
        window.open(this.popItem.pcUrl, "_blank");
      }
    },
    handleLink(item) {
      if (item.pathType == 1) {
        window.open(item.pcPathUrlPlatform, "_blank");
      } else if (item.pathType == 2) {
        if (item.isNoGoingShow == 1 && item.popup.activityStatus == 2) {
          this.popItem = item.popup;
          this.isPopVisiv = true;
        }
        if (item.isNoGoingShow == 0) {
          this.popItem = item.popup;
          this.isPopVisiv = true;
        }
      }
    },
    popups() {
      homeController().then((res) => {
        this.popList = res.data;
        // 排序
        this.popList.sort((a, b) => {
          return a.position - b.position;
        });
        // console.log(res, 11111111111);
      });
    },
    getMenuData() {
      getMenuList().then(async (res) => {
        var routerList = res.data;
        var routerStr = JSON.stringify(routerList);
        routerStr = routerStr.replace(/title/g, "tittle");
        routerList = JSON.parse(routerStr);
        await this.routeLocal(routerList);
        localStorage.setItem("permissionPath", JSON.stringify(this.pathList));
        if (
          this.permissionPath.join() !==
          JSON.parse(JSON.stringify(this.pathList)).join()
        ) {
          // 不关闭页面重新刷新的情况
          // 解决同一路由vue缓存机制不刷新的情况
          // this.$router.push({
          //   path: this.$route.path,
          //   query: { timetemp: Date.parse(new Date()) }
          // })
        }
        this.$store.state.route = routerList;
      });
    },
    // 获取判断云起BI接口
    getBIApi() {
      // TODO: 云起BI接口
      return getYunzhouBiInfo().then((res) => {
        if(res.code == 1) {
          this.$store.commit("setBiInfo", res.data ? res.data : {})
        }
      })

    },
    getSellerPlatform() {
      getSellerPlatform().then((res) => {
        console.log("平台板用户信息", res);
        sessionStorage.setItem("sellerPlatform", JSON.stringify(res.data));
        const { data } = res;
        this.sellerPlatform = data;
        this.platformFlag = data.platformFlag;
        // this.encryptPhone = data.platformAccountInfo.mistinessMobile;
        // 解密手机号
        // decryptPhone({content:res.data.platformAccountInfo.mistinessMobile}).then(res=>{
        //   if(res.code == 1){
        //     this.encryptPhone = res.data
        //   }
        // })
      });
    },
    getSeller() {
      this.loading = true;
      sessionStorage.removeItem("loginUserInfo");
      getSeller().then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.loginUserInfo = res.data;
          sessionStorage.setItem("loginUserInfo", JSON.stringify(res.data));
          this.$store.state.loginUserInfo = res.data;
        } else {
          this.$message.warning(res.message);
        }
      });
    },

    // 将路由存在本地
    routeLocal(list) {
      list.map((item) => {
        if (!item.children) {
          if (item.path == "/home") {
            this.pathList.push("home");
          } else if (item.path == "/industryPreview") {
            this.pathList.push("industryPreview");
          } else {
            if (item.path == "goods_repurchase") {
              // 由于商品复购和商品复购周期分析path相同，所以将title存入用于后续判断
              this.pathList.push(item.tittle);
            }
            this.pathList.push(item.path);
          }
        } else {
          this.routeLocal(item.children);
        }
      });
    },

    // 跳转续费链接
    goRenew() {
      this.buriedPoint(2, "首页-软件续费", "首页", "首页");
      var url = "https://fw.jd.com/main/detail/FW_GOODS-1631?rdct=true";
      window.open(url, "_blank");
    },
    // 跳转续费链接
    goCRM() {
      this.buriedPoint(2, "首页-CRM续费", "首页", "首页");
      var url = "https://fw.jd.com/main/detail/FW_GOODS-1631";
      window.open(url, "_blank");
    },
    goJM() {
      var url = "https://fw.jd.com/main/detail/FW_GOODS-1631";
      window.open(url, "_blank");
    },
    // 跳转续费链接
    goHD() {
      this.buriedPoint(2, "首页-HD续费", "首页", "首页");
      var url = "https://fw.jd.com/main/detail/FW_GOODS-1415006";
      window.open(url, "_blank");
    },

    // 跳转充值页面
    goRecharge() {
      this.buriedPoint(2, "首页-充值", "首页", "首页");
      // let routeUrl = this.$router.resolve({
      //   path: "/backstage/backstage/sms_management",
      // });
      // 新的充值页面
      let routeUrl = this.$router.resolve({
        path: "/tool/backstage/sms_management",
      });
      window.open(routeUrl.href, "_blank");
    },
    // 求两个时间的天数差 日期格式为 YYYY-MM-dd
    daysBetween(DateOne, DateTwo) {
      var OneMonth = DateOne.substring(5, DateOne.lastIndexOf("-"));
      var OneDay = DateOne.substring(
        DateOne.length,
        DateOne.lastIndexOf("-") + 1
      );
      var OneYear = DateOne.substring(0, DateOne.indexOf("-"));

      var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf("-"));
      var TwoDay = DateTwo.substring(
        DateTwo.length,
        DateTwo.lastIndexOf("-") + 1
      );
      var TwoYear = DateTwo.substring(0, DateTwo.indexOf("-"));

      var cha =
        (Date.parse(OneMonth + "/" + OneDay + "/" + OneYear) -
          Date.parse(TwoMonth + "/" + TwoDay + "/" + TwoYear)) /
        86400000;
      return Math.abs(cha);
    },
    // 获取当前时间. 格式为：年-月-日
    getTodayYMD() {
      var date = new Date();
      var year = date.getFullYear();
      var month1 = date.getMonth() + 1;
      var month = month < 10 ? "0" + month1 : month1;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var ymdStr = year + "-" + month + "-" + day;
      return ymdStr;
    },
    //忠诚度管理登录
    toShop() {
      // let routeUrl = this.$router.resolve({
      //   path: "/backstage",
      //   query: { to: "/backstage/sms_management" },
      // });
      window.open(
        `https://mall.jd.com/index-${this.$store.getters.loginUserInfo.shopId}.html`,
        "_blank"
      );
    },
    handlePlatform() {
      var url = "http://yei8.cn/AXsH";
      window.open(url, "_blank");
    },

    toOldVersion() {
      // 返回旧版
      returnOldSystem().then((res) => {
        if (res.code == "1") {
          var url = res.data.url + "?" + "token=" + res.data.token;
          window.location = url;
        }
      });
    },

    getBindList() {
      this.loading = true;
      sessionStorage.removeItem("loginUserInfo");
      getSellerInfo().then((resp) => {
        this.loading = false;
        if (resp.code == 1) {
          this.loginUserInfo = resp.data;
          sessionStorage.setItem("loginUserInfo", JSON.stringify(resp.data));
          this.getShopAllList()
          this.$store.state.loginUserInfo = resp.data;
          this.getShopAllList()
          if(resp.data.permissions.includes("hide:ai:sms:content")){
            this.hasAiPermission = true;
          }
        } else {
          this.$message.warning(resp.message);
        }

        console.log("平台板用户信息", resp);
        sessionStorage.setItem("sellerPlatform", JSON.stringify(resp.data));
        const { data } = resp;
        this.sellerPlatform = data;
        this.platformFlag = data.platformFlag;
        // console.log(resp.data);
        this.editUserInfo(resp && resp.data);
        this.venId = resp.data.venderId;

        const name = resp.data.contactName;
        if (shieldList.indexOf(name) == -1) {
          this.navIogo = true;
        }
        getShopInfo().then((res) => {
          this.fuxinSms = res.data.digitalBalance;
          sessionStorage.setItem("fuxin", res.data.digitalBalance);
          if (res.code == "1") {
            this.dongDongBalance = res.data.dongDongBalance || 0;
            this.saveShopInfo(res && res.data);
            this.shopTitle = res.data.shopTitle;
            var switchList = res.data.bindshop;

            if (switchList.length > 0) {
              var sellerNick = resp.data.sellerNick;
              // console.log("sellerNick:", sellerNick);
              switchList.forEach((item) => {
                if (item.claimer == sellerNick) {
                  item.shopName = item.hostshop;
                } else {
                  item.shopName = item.claimer;
                }
              });
              this.switchList = switchList;
              this.getSwitchList(this.switchList);
            }
          }
        });
      });
    },
    jumpToBi() {
      let targetArr = this.headItem.filter((item) => item.path == "/analysis");
      let isHasYZBi = targetArr[0].children.some((item) => item.path == "bi");
      let isHasYQBi = targetArr[0].children.some((item) => item.path == "yunqi_bi");
      if(this.biInfos.type==1) {
        if (isHasYZBi) {
          let targetRoute = targetArr[0].children.filter(
            (item) => item.path == "bi"
          );
          window.open(
            "/platform/" +
              targetRoute[0].path +
              "/" +
              targetRoute[0].children[0].path,
            "_blank"
          );
        } else {
          this.$router.push({
            path: "/analysis/bi_preview",
          });
        }
      } else if(this.biInfos.type==2&&isHasYQBi) {
        window.open(this.biInfos.yqBiUrl,'_blank')
      } else if(this.biInfos.type==-1) {
        this.$router.push({
          path: "/analysis/bi_preview",
        });
      } else {
        return
      }
    },
    async topTab(ind, item) {
      sessionStorage.removeItem("markNum");
      sessionStorage.removeItem("markId");
      sessionStorage.removeItem("statusNames");
      // 互动营销
      if (item.path == "/interactive") {
        const res = await getSeller();
        if (res.data.isOrderHd) {
          window.open(
            "https://open-oauth.jd.com/oauth2/to_login?app_key=22AF00009B3D46B8DECBC457090B3560&response_type=code&redirect_uri=http://jdhd.tj9.co/jd-hd-web/yhd/auth/callback&state=jdShop&scope=snsapi_base",
            "_blank"
          );
          return;
        }
      }
      this.topActive = ind;
      this.activeNavStyle = this.getNavStyle(ind);
      var path = item.path;

      if (item.children && item.children[0].path) {
        path = item.path + "/" + item.children[0].path;
      }

      if (
        item.children &&
        item.children[0].path &&
        item.children[0].children &&
        item.children[0].children[0].path
      ) {
        path =
          item.path +
          "/" +
          item.children[0].path +
          "/" +
          item.children[0].children[0].path;
      }
      // 新页面打开 bi
      if (item.path == "bi") {
        window.open("/platform/" + path, "_blank");
        return;
      }
      // console.log("path==", path);
      this.$router.push({ path: path });
      this.$emit('itemClick',item.children,item)
      this.bus.$emit("topActive", { index: ind, item: item });
      if (item.path == "/integralCenter") {
        this.loginEvent();
      }
    },
    toOther(item) {
      let path = item.children[0].path;
      window.open("/platform/" + path, "_blank");
    },
    toBi(item) {
      console.log(item.path, "----------------------");
      this.pathsOne = item.path;
      sessionStorage.setItem("pathsOne", item.path);
      let path = item.children[0].path;
      this.$emit("getBiList", item.children);
      window.open("/platform/bi/" + "customTable", "_blank");
    },
    toIndustryPreview() {
      window.open("/platform/industryPreview", "_blank");
    },
    //登录
    loginEvent() {
      let venderId = { venderId: this.venId };
      console.log(venderId);
      // let venderId = { venderId: "10231814" };
      // loginController(venderId)
      //   .then((res) => {
      //     sessionStorage.setItem("loginValue", res.code);
      //     // console.log(res);
      //     if (res && res.code == 1) {
      //       if (
      //         res.data.appInfo.status == 1 &&
      //         res.data.orderInfo.status == 1
      //       ) {
      //         console.log("登录成功");
      //         this.editPointUserInfo(res.data.orderInfo)
      //       } else if (res.data.orderInfo.status != 1) {
      //         let routeUrl = this.$router.resolve({
      //           path: "/prizeCenter2",
      //         });
      //         window.open(routeUrl.href, "_blank");
      //         window.open("/home", "_self");
      //       } else {
      //         window.open(res.data.appInfo.authUrl, "_blank");
      //         window.open("/home", "_self");
      //       }
      //     } else {
      //       if (res.data.data.orderInfo.status != 1) {
      //         let routeUrl = this.$router.resolve({
      //           path: "/prizeCenter2",
      //         });
      //         window.open(routeUrl.href, "_blank");
      //       } else {
      //         window.open(res.data.data.appInfo.authUrl, "_blank");
      //       }
      //       window.open("/home", "_self");
      //     }
      //   })
      //   .catch((res) => {
      //     this.$message.error("积分登录失败");
      //     window.open("/home", "_self");
      //   });
    },

    toBindShop() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/account/store_binding",
        // query: { to: "/account/store_binding" },
      });
      window.open(routeUrl.href, "_blank");
    },
    // 跳转到充值页面
    toRecharge() {
      // this.$router.push({ path: "/backstage" ,query: {to:'/backstage/smsmanage/charge'}});
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/sms_management" },
      });
      window.open(routeUrl.href, "_blank");
      // this.$router.push({ path: "sms_management"});
      // this.$router.push("/integralCenter/shopDecoration");
    },
    toRecharge1() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/sms_management", id: 1 },
      });
      window.open(routeUrl.href, "_blank");
    },
    toRecharge2() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/sms_management", id: 2 },
      });
      window.open(routeUrl.href, "_blank");
    },
    //去设置页面
    toSetting() {
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/account/account" },
      });
      window.open(routeUrl.href, "_blank");
    },
    switchStore() {
      this.accountSwitches = !this.accountSwitches;
    },
    // 去中台页
    toOverFlow() {
      if (this.newplatformFlag) {
      window.location =
        "/jd-yusms/yunzhou-common/system-redirect?redirectUrl=/overflow";
      }else{
       this.$router.push("/home");
      }
    },
    //退出登录
    log_out() {
      if (this.newplatformFlag) {
        logout().then((res) => {
          location.href = "https://yz.yqcrm.cn/login";
        }).catch((err) => {
          console.log(err);
          location.href = "https://yz.yqcrm.cn/login";
        })
      }else{
        logout().then((res) => {
          location.href = res.data
        })
      }
    },
    toggleSwitch(item) {
      console.log(this.newplatformFlag);

      console.log(item);
      // return
      let params = {};
      if (this.newplatformFlag) {
        params.sellerNick = item.hostshop;
      } else {
        params.sellerNick =
          item.claimerShopTitle == this.shopTitle ? item.hostshop : item.claimer;
      }
      switchShop(params).then((res) => {
        if (res.code == "1") {
          this.$message.success("切换成功");
          // 清除 session 中的 sellerPlatform
          sessionStorage.removeItem("sellerPlatform");
          // 刷新页面重新获取接口数据
          setTimeout(() => {
            window.location.reload(true);
          }, 1000);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    feedback() {
      this.$emit("openWindow", true);
    },
    getNavStyle(index) {
      if (sessionStorage.getItem("pathsOne") == "/bi") return;
      let childNodes = this.$refs.mainHeader.childNodes;
      let width = Number(childNodes[index] && childNodes[index].clientWidth);
      let left = 0;
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          if (this.screenWidth < 1370) {
            left += childNodes[i].clientWidth + 5;
          } else if (this.screenWidth > 1369 && this.screenWidth < 1572) {
            left += childNodes[i].clientWidth + 5;
          } else if (this.screenWidth > 1572 && this.screenWidth < 1800) {
            left += childNodes[i].clientWidth + 29;
          } else {
            left += childNodes[i].clientWidth + 10;
          }
        }
      }
      return { width, left };
    },

    // 求两个时间的天数差 日期格式为 YYYY-MM-dd
    daysBetween(DateOne, DateTwo) {
      var OneMonth = DateOne.substring(5, DateOne.lastIndexOf("-"));
      var OneDay = DateOne.substring(
        DateOne.length,
        DateOne.lastIndexOf("-") + 1
      );
      var OneYear = DateOne.substring(0, DateOne.indexOf("-"));

      var TwoMonth = DateTwo.substring(5, DateTwo.lastIndexOf("-"));
      var TwoDay = DateTwo.substring(
        DateTwo.length,
        DateTwo.lastIndexOf("-") + 1
      );
      var TwoYear = DateTwo.substring(0, DateTwo.indexOf("-"));

      var cha =
        (Date.parse(OneMonth + "/" + OneDay + "/" + OneYear) -
          Date.parse(TwoMonth + "/" + TwoDay + "/" + TwoYear)) /
        86400000;
      return cha < 0 ? 1 : Math.abs(cha);
    },

    // 获取当前时间. 格式为：年-月-日
    getTodayYMD() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var month = month < 10 ? "0" + month : month;
      var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      var ymdStr = year + "-" + month + "-" + day;
      return ymdStr;
    },
    // handleUrl() {
    //   this.$router.push({ name: "sms_management" });
    // },

    //复制
    copyBtn(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      let isTrue = document.execCommand("Copy"); // 执行浏览器复制命令
      if (isTrue) {
        this.$message.success("复制成功！");
      } else {
        this.$message.error("复制失败！");
      }
      oInput.remove();
    },

    closeDialog() {
      this.phoneForm = {
        phone: "",
        code: "",
      };
      this.phoneDialog = false;
      if (this.phonedown === 60) this.phonecodeMsg = "发送验证码";
    },
    savePhone() {
      if (!this.phoneForm.phone) {
        this.$message.warning("请输入新手机号、新手机号输入错误，请重新输入");
        return;
      } else if (this.isPhoneNum(this.phoneForm.phone) == false) {
        this.$message.warning("请输入新手机号、新手机号输入错误，请重新输入");
        return;
      }
      if (!this.phoneForm.code) {
        this.$message.warning("请输入验证码");
        return;
      }
      let params = {
        mobile: this.phoneForm.phone,
        vcode: this.phoneForm.code,
      };
      updatePlatformAccountMobile(params)
        .then((res) => {
          if (res.code == 1) {
            this.phoneDialog = false;
            this.$message.success("修改成功");
            this.getSellerPlatform();
          } else {
            console.log(res);
            console.log("Error: " + res.code);
            this.$message.warning(res.message);
          }
        })
        .catch(() => {});
    },
    changePhone() {
      this.phoneForm = {
        phone: "",
        code: "",
      };
      this.phonecodeMsg = "发送验证码";
      clearInterval(this.codeTimer);
      this.phonecodeDisabled = false;
      this.phonedown = 60;
      this.phoneDialog = true;
    },
    getPhoneCode() {
      if (!this.phoneForm.phone) {
        this.$message.warning("请输入新手机号、新手机号输入错误，请重新输入");
        return;
      } else if (this.isPhoneNum(this.phoneForm.phone) == false) {
        this.$message.warning("请输入新手机号、新手机号输入错误，请重新输入");
        return;
      }
      let params = {
        bindingPhone: this.phoneForm.phone,
        source: 1,
      };

      getCheckCode(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("已发送");
            this.codeTimer = window.setInterval(() => {
              this.phonedown--;
              this.phonecodeDisabled = true;
              this.phonecodeMsg = `已发送 ${this.phonedown}s`;
              if (this.phonedown == 0) {
                clearInterval(this.codeTimer);
                this.phonecodeMsg = "重新获取";
                this.phonecodeDisabled = false;
                this.phonedown = 60;
              }
            }, 1000);
          } else {
            console.log("Error: " + res.code);
            this.phonecodeDisabled = false;
            this.$message.info(res.message);
          }
        })
        .catch(() => {
          this.phonecodeDisabled = false;
        });
    },

    // 修改密码
    handleChangePwd() {
      this.editForm = {
        platformCompanyUserId:
          this.sellerPlatform.platformAccountInfo.platformCompanyUserId,
        oldPassword: "",
        newPwd: "",
        confirmPassword: "",
      };
      this.showEditPwd = true;
    },
    handleEditPwdClose() {
      this.editForm = {
        platformCompanyUserId: "",
        oldPassword: "",
        password: "",
        confirmPassword: "",
      };
      this.showEditPwd = false;
    },
    itemClick(val) {
      this.$emit("itemClick", val);
    },
    changeAiType(type) {
      console.log(type);
      if (type == 1) {
        this.showAI = true;
        this.showAiService = false;
      } else {
        this.showAI = false;
        this.showAiService = true;
      }
    },
    // 跳转至客服工具
    async jumpToCustomer() {
      this.getBindList();
      let {
        dongCusExpiredIn = null,
        isBindDongUser = false,
        dongDomain,
        dongUserAccountName = "",
      } = this.loginUserInfo;
      if (
        !dongCusExpiredIn ||
        (dongCusExpiredIn && new Date(dongCusExpiredIn) <= new Date())
      ) {
        this.validityDialog = true;
        return;
      }
      if (!isBindDongUser) {
        this.$message.warning(
          "当前登陆的云起账号未绑定官方账号，请联系超级管理员绑定后使用～"
        );
        return;
      }
      try {
        const res = await getJumpDD({
          dongUserAccountName,
          jumpType: 3,
        });
        let url = res.data ? JSON.parse(res.data) : "";
        url && window.open(url);
      } catch (error) {
        this.$message.warning("获取地址失败");
      }
    },
    toLaunch() {
      window.open("https://fw.jd.com/main/detail/FW_GOODS-1863223");
    },
    // 获取下单店铺接口
    getShopAllList() {
      const list = [
        {
          shopTitle: this.loginUserInfo.shopTitle,
          venderId: this.loginUserInfo.venderId,
          venderType: this.loginUserInfo.venderType,
          defaultFlag: true,
        }
      ];
      getShopList()
        .then((res) => {
          if (res.code == 1) {
            const resData = res.data.filter((item) => item);
            if (resData && resData.length) {
              // 灰度判断
              if(this.loginUserInfo.isGray) {
                this.shopList = list;
              } else {
                this.shopList = resData;
              }
          
            } else {
              this.shopList = list;
            }
            this.$store.commit("setShopList", this.shopList)
          } else {
            this.shopList = list;
            this.$store.commit("setShopList", this.shopList)
          }
        })
        .catch(() => {
          this.shopList = list;
          this.setShopList(this.shopList)
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.header-class {
  //background: #FFFFFF;
  min-width: 1349px;
}
.header-class__home {
  //background: #FFFFFF;
  // min-width: 1349px;
  //box-shadow: 0 0 7px 3px rgba(0, 0, 0, 0.03);
}
/deep/ .theme-picker {
  left: 5px;
  opacity: 0;
}
.displayStart {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.displayBetween {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.displayCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}
.rightContent {
  // max-width: 272px;
  // min-width: 200px;
  // top: 0;
  // right: 16px;
  // position: absolute;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  color: #333333;
  height: 60px;
  // line-height: 60px;
  text-align: center;
  padding-right: 30px;

  .white-bar {
    width: 90px;
    height: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    margin-right: 30px;
  }

  .ai_button {
    height: 100%;
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
    cursor: pointer;
    line-height: 60px;
    display: flex !important;
    align-items: center;
    cursor: pointer;
  }

  .helpBlock {
    margin: 0 30px;
    height: 60px;
    .title {
      margin-right: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
    }
    .helpCenterClick {
      display: none;
    }
    .tips {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #ffffff;
    }
  }
  // .helpBlock:hover{
  //   .helpCenter{
  //     display: none;
  //   }
  //   .helpCenterClick{
  //     display: block;
  //   }
  // }

  .shopBlock {
    height: 60px;
    .title {
      margin-right: 4px;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
    }
    .shopIconClick {
      display: none;
    }
    .tips {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #ffffff;
      margin-right: 30px;
    }
  }
  // .shopBlock:hover{
  //   .shopIcon{
  //     display: none;
  //   }
  //   .shopIconClick{
  //     display: block;
  //   }
  // }

  .head-name {
    .head-name-tit {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      max-width: 106px;
    }
    //   @media screen and (max-width: 1780px) {
    //     display: none;
    //   }
  }
}
.customerService {
  font-size: 12px;
  padding: 10px;
  .title {
    font-weight: 400;
    font-size: 13px;
    color: #666666;
  }
  .toService {
    margin-bottom: 12px;
    .title {
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 15px;
    }
    .phone {
      display: flex;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 16px;
      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
        margin-left: 6px;
      }
    }
  }

  .wechatService {
    margin-top: 17px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .QRcode {
      width: 80px;
      height: 80px;
      .title {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        line-height: 14px;
        text-align: left;
      }
    }
  }

  .copyBtnHover {
    display: none;
  }
  .copyBtn {
    display: block;
  }
}
.phoneBtn:hover {
  .copyBtn {
    display: none;
  }
  .copyBtnHover {
    display: block;
  }
}
.help {
  margin-bottom: 31px;
  display: flex;
  // padding: 0 10px;
  justify-content: flex-start;

  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 14px;
  color: #666666;
  cursor: pointer;
  div {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    border-radius: 4px 4px 4px 4px;
    opacity: 1;
    width: 100px;
  }
  .helpNoHover {
    display: flex;
  }
  .helpHover {
    display: none;
  }
}
.help:hover {
  .helpHover {
    display: flex;
  }
  .helpNoHover {
    display: none;
  }
}
.help div:hover {
  color: #2e74fe;
}
.details {
  width: 100%;
  padding: 12px;
  .shopTitle {
    margin-bottom: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .title {
      font-weight: 600;
      font-size: 12px;
      color: #333333;
      line-height: 16px;
      margin-left: 4px;
    }
  }
  .details_top {
    display: flex;
    flex: 1;
    text-align: left;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 9px;
    .txt {
      font-weight: 400;
      font-size: 12px;
      color: #666666;
      line-height: 16px;
      margin-top: 4px;
    }
    .autograph {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 16px;
    }
  }

  .details_bottom {
    padding-top: 4px;
    border-top: 1px dashed rgba(0, 0, 0, 0.15);
    .bottom_content {
      padding-top: 12px;
      .text {
        font-size: 12px;
        color: #666666;
      }
      > div:first-child {
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div:first-child {
          > span:last-child {
            font-weight: bold;
          }
        }
      }
    }
    .left_content {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .txt {
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      line-height: 16px;
    }
    .time {
      font-size: 12px;
      color: #333333;
      line-height: 16px;
    }
    .question-icon {
      display: inline-block;
      width: 16px;
      height: 16px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      background-color: #999;
      color: #fff;
      font-size: 12px;
      margin-left: 8px;
      cursor: help;
    }
    .payBtn {
      font-weight: 400;
      font-size: 12px;
      color: #2e74fe;
      line-height: 18px;
    }
  }

  .recharge,
  .renew {
    width: 48px;
    height: 24px;
    border-radius: 2px 2px 2px 2px;
    border: 1px solid #dcdfe6;
    font-weight: 400;
    font-size: 12px;
    color: #1f1f1f;
    line-height: 15px;
    &:hover {
      color: #666666;
      background: #f2f3f5;
    }
    &:active {
      color: #666666;
      background: #f2f3f5;
    }
  }
}

.switch-content {
  font-weight: 400;
  font-size: 12px;
  color: #333333;
  white-space: nowrap;
  overflow: visible;
  text-overflow: ellipsis;
  cursor: pointer;
  padding: 0 10px;
  line-height: 36px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.switch-content.active {
  color: #2e74fe;
}
.switch-content:hover {
  // color: #FE4D45;
  height: 36px;
  background: #f5f5f7;
  .shop-name-setDefault {
    display: inline-block;
  }
  .shop-name-empty {
    display: none;
  }
}
.shop-name {
  display: flex;
  align-items: center;
  &-default {
    border-radius: 4px;
    color: #fff;
    background-color: #2768ff;
    font-size: 10px;
    line-height: normal;
    padding: 2px 4px;
    margin-left: 8px;
  }
  &-setDefault {
    display: none;
  }
  &-empty {
    width: 56px;
  }
}
.callkf1 {
  border-top: 1px solid #eeeeee;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 16px;
  text-align: center;
  /* margin: 0 auto; */
  cursor: pointer;
  padding: 16px;
  margin-bottom: 6px;
}
.information {
  margin: 16px 0;
  font-weight: 400;
  font-size: 12px;
  color: #333333;
}
.changeBtn {
  cursor: pointer;
  font-weight: 400;
  font-size: 12px;
  color: #2e74fe;
}
.top {
  display: flex;
  justify-content: center;
  position: absolute;
  top: -14px;
  left: 110px;
  img {
    width: 20px;
    height: 20px;
  }
}
.line {
  margin-top: 20px;
  margin-bottom: 20px;
}

.container {
  overflow: hidden;
  height: 50px;
  width: 100%;
  margin-bottom: 16px;
  transition: all 0.5s;
  // position: fixed;
  // top: 0;
  // left: 0;
  z-index: 10;
  // max-width: 1920px;
  // margin: 0px auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #3159ff;
  background-image: url("~@/assets/homePage/head.png");
  background-size: 100% 100%; /* 背景图片覆盖整个元素 */
  background-repeat: no-repeat; /* 背景图片不重复 */
  .logo {
    box-sizing: border-box;
    width: 200px;
    opacity: 1;
    vertical-align: top;
    display: inline-block;
    height: 60px;
    text-align: center;
    line-height: 65px;
    // @media screen and (min-width: 1500px) and (max-width: 1700px) {
    //   line-height: 68px;
    // }
    // @media screen and (min-width: 1400px) and (max-width: 1499px) {
    //   line-height: 69px;
    // }
    // @media screen and (max-width: 1399px) {
    //   line-height: 70px;
    // }
    padding: 5px 0;
    text-align: center;
    img {
      display: inline-block;
      margin-top: -22px;
      // width: 140px;
      // @media screen and (max-width: 1366px) {
      //   margin-top: -24px;
      // }
      // height: 40px;
      vertical-align: middle;
    }
    img:after {
      content: "";
      display: inline-block;
      vertical-align: middle;
    }
  }
  .module {
    // display: inline-block;
    // margin-left: 20px;
    min-width: 444px;
    display: flex;
    align-items: center;
    // @media screen and (min-width: 1500px) and (max-width: 1800px) {
    //   margin-left: 0;
    //   overflow: auto;
    //   // width: 66%;
    // }
    // @media screen and (min-width: 1400px) and (max-width: 1499px) {
    //   margin-left: 0;
    //   overflow: auto;
    //   // width: 62%;
    // }
    // @media screen and (max-width: 1399px) {
    //   margin-left: 0;
    //   overflow: auto;
    //   // width: 58%;
    // }
    .nav {
      // display: inline-flex;
      position: relative;
      height: 50px;
      display: flex;
      align-items: center;
      overflow: hidden;
      margin-left: 38px;
      .nav-item {
        position: relative;
        margin-right: 20px;
        // bottom: 5px;
        font-size: 14px;
        color: #ffffff;
        cursor: pointer;
        // &:hover::before {
        //   bottom: -5px;
        //   opacity: 1;
        //   // @media screen and (max-width: 1300px) {
        //   //   bottom: -2px;
        //   // }
        // }
        // &::before {
        //   content: "";
        //   position: absolute;
        //   bottom: -11px;
        //   left: 0;
        //   width: 100%;
        //   height: 4px;
        //   background-color: #555a7a;
        //   border-radius: 8px 8px 0 0;
        //   // opacity: 0;
        //   // transition: 0.3s;
        // }
      }
      .nav-item.bi {
        position: relative;
        &::before {
          content: "";
          display: inline-block;
          width: 30px;
          height: 16px;
          background-image: url(".././assets/homeDemo/produce.svg");
          position: absolute;
          bottom: 75%;
          left: 60%;
        }
      }
      .nav-item.shopDecoration {
        position: relative;
        &::before {
          content: "";
          display: inline-block;
          width: 28px;
          height: 12px;
          background-image: url(".././assets/homeDemo/shopDecoration.svg");
          position: absolute;
          bottom: 100%;
          left: 60%;
        }
      }
      .nav-pcImgUrl {
        padding: 0;
        &::before {
          background-color: transparent !important;
        }
      }
      .navLeft {
        margin-left: -45px;
      }
      .nav-underline {
        position: absolute;
        bottom: 0;
        display: block;
        height: 4px;
        top: 56px;
        border-radius: 8px 8px 0 0;
        background-color: #fe4d45;
        transition: all 0.4s ease-in-out;
      }
      .navActive {
        font-weight: bold;
        font-size: 14px;
        color: white;
      }
      // .nav-item.navActive {
      //   // &::before {
      //   //   bottom: 0;
      //   //   opacity: 1;
      //   //   background-color: #FE4D45;
      //   // }
      // }
    }
    .item {
      position: relative;
      display: inline-block;
      font-size: 16px;
      font-weight: 400;
      color: #d5d6de;
      line-height: 30px;
      text-align: center;
      margin-left: 64px;
      cursor: pointer;
      height: 30px;
      &:hover {
        color: white;
        &::before {
          content: "";
          width: 150%;
          background-color: #555a7a;
          height: 4px;
          font-size: 16px;
          position: absolute;
          bottom: -11px;
          border-radius: 4px;
          left: -50%;
          transform: translateX(18%);
        }
      }
    }
    .active {
      width: 150%;
      background-color: #fe4d45;
      height: 4px;
      font-size: 16px;
      position: absolute;
      bottom: -11px;
      border-radius: 4px;
      left: -50%;
      transform: translateX(18%);
    }
    .item.tabActive {
      color: #fff !important;
    }
  }
}

.headerContactBox {
  padding: 20px 10px !important;
  .info {
    padding: 0 9px 17px 9px;
    border-bottom: 1px solid #f3f3f3;
    color: #333;
    font-size: 14px;
    .labelTxt {
      display: inline-block;
      width: 65px;
    }
    .btnContact {
      position: relative;
      margin-left: 6px;
      padding: 0 15px;
      line-height: 20px;
      height: 20px;
      border-radius: 2px;
      border: 1px solid #ccc;
      background: #fff;
      font-size: 14px;
      color: #999;
      cursor: pointer;
      transition: all 0.2s linear;
      outline: none;
      .hoverIcon {
        position: absolute;
        left: 15px;
        top: 3px;
        opacity: 0;
      }
      &:hover {
        color: #5882fb;
        border: 1px solid #5882fb;
        background: rgba(88, 130, 251, 0.1);
        .icon {
          opacity: 0;
        }
        .hoverIcon {
          width: 13px;
          height: 13px;
          opacity: 1;
        }
      }
    }
  }
  .foot {
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    .btn {
      width: 110px;
      height: 28px;
      line-height: 26px;
      border: 1px solid #ccc;
      color: #999;
      border-radius: 2px;
      cursor: pointer;
      transition: all 0.2s linear;
      display: flex;
      align-items: center;
      justify-content: center;
      &:hover {
        color: #5882fb;
        background: rgba(88, 130, 251, 0.1);
        border: 1px solid rgba(88, 130, 251, 1);
      }
      &:active {
        color: #3d6fff;
        background: rgba(88, 130, 251, 0.1);
        border: 1px solid rgba(61, 111, 255, 1);
      }
    }
  }
}
// @media screen and (min-width: 1572px) and (max-width: 1800px) {
//   .container {
//     .module {
//       .nav {
//         margin-left: 18px;
//         .nav-item {
//           // margin-right: 29px;
//         }
//         .navLeft {
//           margin-left: -29px;
//         }
//       }
//     }
//   }
// }
// @media screen and (min-width: 1480px) and (max-width: 1572px) {
//   .container {
//     .module {
//       .nav {
//         margin-left: 9px;
//         .nav-item {
//           margin-right: 5px;
//         }
//         .nav-pcImgUrl {
//           margin-right: 15px;
//         }
//         .navLeft {
//           margin-left: -5px;
//         }
//       }
//     }
//   }
// }
// @media screen and (min-width: 1400px) and (max-width: 1480px) {
//   .container {
//     .module {
//       .nav {
//         margin-left: 4px;
//         .nav-item {
//           margin-right: 0;
//           width: 80px;
//           font-size: 16px;
//           padding: 0 5px;
//           &:hover {
//             font-weight: bold;
//             font-size: 16px;
//             color: #1f1f1f;
//           }
//         }
//       }
//     }
//   }
// }
// @media screen and (max-width: 1400px) {
//   .container {
//     .module {
//       .nav {
//         margin-left: 4px;
//         .nav-item {
//           margin-right: 0;
//           width: 72px;
//           font-size: 14px;
//           padding: 0 5px;
//           &:hover {
//             font-weight: bold;
//             font-size: 14px;
//             // color: #1F1F1F;
//           }
//         }
//       }
//     }
//   }
// }
</style>

<style lang="scss">
.dialongTransition12 {
  .el-dialog {
    background: transparent;
    box-shadow: none !important;
    // box-shadow: 0 0px 0px rgba(0, 0, 0, 0.3);
    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      background: transparent;
    }
  }
}

.platformFlag.el-popover {
  padding: 0px !important;
}
.outWidth {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  // width: 140px;
  margin: 0 8px;
  .storeName {
    font-size: 12px;
    color: #ffffff;
  }
}
.shopSwitch {
  border-bottom: 1px solid #eeeeee;
  max-height: 185px;
  overflow-y: auto;
  overflow-x: hidden;
  // /* 隐藏滚动条（仅适用于 Internet Explorer 和 Edge） */
  // -ms-overflow-style: none;

  // /* 隐藏滚动条（适用于 Firefox） */
  // scrollbar-width: none;
}
.welcome {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  text-align: left;
  margin: 0 24px 0 14px;
}
.shopTitle {
  text-align: left;
}
.bi-menu {
  color: #fff;
  .down-icon {
    margin-left: 2px;
  }
}
.mt4 {
  margin-top: 4px;
}
// @media screen and (max-width: 1360px) {
//   .welcome {
//     display: none;
//   }
//   .rightContent {
//     .shopBlock {
//       margin-right: 0;
//     }
//   }
//   .outWidth {
//     width: 137px;
//   }
//   .shopTitle {
//     margin: 0 0 0 8px;
//   }
// }
</style>

<style lang="scss" scoped>
.validityText {
  color: #2768ff;
  text-decoration: underline;
  cursor: pointer;
}
.fs12 {
  font-size: 12px;
}
.colorfff {
  color: #fff !important;
}
</style>
